import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { accessControl } from '../utils/tools';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'login',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue'),
  },
  {
    path: '',
    name: 'home—manager',
    meta: {
      title: '预警大屏',
      authType: 'ASP_HOME',
    },
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/home/index.vue'),
        meta: {
          title: '首页',
          authType: 'ASP_HOME_PAGE',
        },
      },
      {
        path: '/detect',
        name: 'detect',
        component: () => import('../views/detect/index.vue'),
        meta: {
          title: '侦测',
          authType: 'DETECT',
        },
      },
    ],
  },
  {
    path: '/digital-base',
    name: 'digital-base',
    component: () => import('../views/digital-base/index.vue'),
    meta: {
      title: '数字底座',
      authType: 'DIGITAL_BASE',
    },
  },
  {
    path: '/grid-management',
    name: 'grid-management',
    component: () => import('../views/grid-management/index.vue'),
    meta: {
      title: '网格管理',
      authType: 'GRID_MANAGEMENT',
    },
  },
  {
    path: '/flight-navigation',
    name: 'flight-navigation',
    component: () => import('../views/flight-navigation/index.vue'),
    meta: {
      title: '飞行路径',
      authType: 'FLIGHT_NAVIGATION',
    },
  },
  {
    path: '/road-network',
    name: 'road-network',
    component: () => import('../views/road-network/index.vue'),
    meta: {
      title: '路网规划',
      authType: 'GRID_MANAGEMENT',
    },
  },
  {
    path: '',
    name: 'task-manage',
    meta: {
      title: '任务管理',
      authType: 'TASK_MANAGE',
    },
    children: [
      {
        path: '/apply-fly',
        name: 'apply-fly',
        component: () => import('../views/task-manage/apply-fly/index.vue'),
        meta: {
          title: '飞行活动申请',
          authType: 'APPLY_FLY',
        },
      },

      {
        path: '/my-operator',
        name: 'my-operator',
        component: () => import('../views/task-manage/my-operator/index.vue'),
        meta: {
          title: '我的操控员',
          authType: 'OPERATOR_MANAGE',
        },
      },
    ],
  },
  {
    path: '/my-aircraft',
    name: 'my-aircraft',
    component: () => import('../views/task-manage/my-aircraft/index.vue'),
    meta: {
      title: '我的航空器',
      authType: 'AIRCRAFT_MANAGE',
    },
  },
  {
    path: '/digital-weather',
    name: 'digital-weather',
    component: () => import('../views/digital-base/Weather/index.vue'),
    meta: {
      title: '气象',
      authType: 'DIGITAL_BASE_WEATHER',
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;

// ====== 基于 authType 的权限路由守卫 ======

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('token');
  if (!token && to.name !== 'login') {
    next('/login');
    return;
  }
  const authType = to.meta && (to.meta as any).authType;
  if (authType) {
    if (accessControl(authType)) {
      next();
    } else {
      // 没有权限，返回上一个页面，如果没有来源则跳转首页
      // 如果从登录页进来没有首页权限，则跳转 /
      if (from && from.fullPath && from.fullPath !== to.fullPath && from.fullPath !== '/login') {
        next(from.fullPath);
      } else {
        next('/');
      }
    }
  } else {
    next();
  }
});
